<template>
  <v-card class="rounded-card card-shadow fill-height">
    <v-card-title class="font-weight-bold pl-5">
      Listagem de ofertas mais acessadas
    </v-card-title>
    <v-card-text class="text--primary">
      <div>
        <px-dashboard-acessos-lista-ofertas
          :ofertas="ofertas" :loading="loading"
          :on-change-options="onChangeOptions"
          :options-list="optionsList"
          @update="onClickRefresh"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import DashboardAcessosService from '../dashboard-acessos';
import DashboardAcessosListaOfertas from './DashboardAcessosListaOfertas.vue';

export default {
  props: {
    dataMes: Object,
  },
  mixins: [paginationMixin],
  data() {
    return {
      ofertas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: '',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
    };
  },
  computed: {
    query() {
      return `data >= ${this.dataMes.initialDate} and data <= ${this.dataMes.finalDate}`;
    },
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getOfertas();
    },
    onClickRefresh() {
      this.getOfertas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getOfertas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      this.listOptions.filter = this.query;

      return DashboardAcessosService.getOfertasAcessadas({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.ofertas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dataMes(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.resetPage();
      this.onClickRefresh();
    },
  },
  components: {
    pxDashboardAcessosListaOfertas: DashboardAcessosListaOfertas,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
